export default __webpack_public_path__ + "static/media/upload.a4fdf09f.svg";